import { isFinanceProject, isGlobalProject } from 'config';

export const getClientPersonalAccountFormSectionKeys = (): string[] => {
  if (isFinanceProject()) {
    return ['accountCodes', 'serviceContract', 'openAccountOrder'];
  }

  if (isGlobalProject()) {
    return ['accountCodes', 'serviceContract'];
  }

  return [];
};
